// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yhnr","fullView":"styles_fullView__dGCHC"};